
	     
const columnList: Array<any> = [
    {
        prop: "branch_name",
        label: "部门名称",
        width: 150,
    },
    {
        prop: "sort",
        label: "排序",
        width: 100,
    }
 
];
import {Request} from '@/api/request';

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
} from "vue";
import { getPurchaseTable, getSupplierList } from "@/api/http";
import { column } from "@/assets/types/common";
import { storeUser } from "@/store/User";

export default defineComponent({
    name: "personnelBranch",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["部门管理"]);
        let pageSize = ref(10),
            currentPage = ref(1),
            user = storeUser.getUser(),
            tableData = ref([] as Array<any>),
            loading = ref(true),
            headClass = inject("headClass"),
            screenParameter: any = {
                page: currentPage.value,
                limit: pageSize.value,
                search: "",
                branch_id: ""
            },
            dialog_show = ref(false),
			dialog_title = ref(''),
			form = ref({
				branch_id: 0,
				branch_name: '',
				sort: ''
			}),
			formRef = ref(null),
			form_isload = ref(false),
			form_rules = {
				branch_name: [
					{required: true, message: '请输入部门名称', trigger: 'blur'},
				]
			},
            getTableData = (): void => {
                loading.value = true;
				Request.axiosInstance({
					url: 'adminapi/Branch/list',
					data: screenParameter
				}).then((res: any) => {
					tableData.value = res?.content?.list || [];
					loading.value = false;
				})
            },
			_uprowStatus = (id: number, status: number): void => {
				loading.value = true
				Request.axiosInstance({
					url: 'adminapi/Branch/upState',
					data: {branch_id: id, status: (status == 0 ? 1 : 0)}
				}).then((res: any) => {
					getTableData()
				})
			},
			_editinfo = (id: number, name: string, sort: string) => {
				form.value = {
					branch_id: id,
					branch_name: name,
					sort: sort
				}
				dialog_title.value = '修改部门'
				dialog_show.value = true
				form_isload.value = false
			},
			_addinfo = () => {
				form.value = {
					branch_id: 0,
					branch_name: '',
					sort: ''
				}
				dialog_title.value = '增加部门'
				dialog_show.value = true
				form_isload.value = false
			},
			_formSubmit = () => {
				form_isload.value = true
				
				
				Request.axiosInstance({
					url: dialog_title.value == '增加部门' ? 'adminapi/Branch/create' : 'adminapi/Branch/edit',
					data:  form.value
				}).then(() => {
					dialog_show.value = false
					getTableData()
				})
			}
          
 
        onMounted(() => {
            getTableData();
        });

        return {
            columnList,
            tableData,
            loading,
            headClass,
            screenParameter,
			_uprowStatus,
			dialog_show,
			dialog_title,
			form,
			formRef,
			form_rules,
			form_isload,
			_editinfo,
			_formSubmit,
			_addinfo,
            user
        };
    },
});
